import { render, staticRenderFns } from "./event-code-label.vue?vue&type=template&id=3887dff8&scoped=true"
import script from "./event-code-label.vue?vue&type=script&lang=js"
export * from "./event-code-label.vue?vue&type=script&lang=js"
import style0 from "./event-code-label.vue?vue&type=style&index=0&id=3887dff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887dff8",
  null
  
)

export default component.exports